import { useDecision } from "@optimizely/react-sdk";
import { useTranslation } from "react-i18next";
import { NubImageUpload, Switch, RowInfo } from "../../common";
import { StickerModal, StickerStyleModal } from "../modals";

const StickerPhoto = ({ useQuery }) => {
  const { t } = useTranslation();
  const [decisionStickerify] = useDecision('stickerify');
  const [collection, setCollection] = useQuery();

  const clearOverlay = () => {
    setCollection({
      assets: {
        ...collection.assets,
        photos: (collection.assets?.photos || []).filter(asset => asset.name !== "sticker"),
      },
      overlay_media_uuid: null,
      overlay_media_extension: null,
    });
  };

  return (
    <>
      <p>{t('Ask players to place a sticker on top of a photo.')}</p>
      <RowInfo help={<StickerModal />} isFull>
        {
          decisionStickerify?.enabled
            ? (
              <NubImageUpload
                label={t("Sticker")}
                name="overlay"
                useQuery={useQuery}
                maxImages={1}
                withAi={!collection?.fullscreen}
                stickerify
                storageMode="asset"
                assetName="sticker"
                mediaPrefix="overlay"
              />
            )
            : (
              <NubImageUpload label={t("Sticker")} name="overlay" useQuery={useQuery} storageMode="legacy" />
            )
        }
      </RowInfo>
      <RowInfo help={<StickerStyleModal />}>
        <Switch
            label={t("Fullscreen")}
            labels={{ on: t("Yes"), off: t("No") }}
            name="fullscreen"
            on={true}
            off={false}
            useQuery={useQuery}
            onChange={clearOverlay}
          />
      </RowInfo>
    </>
  );
};

/** @deprecated Use NubImageUpload for builder image upload controls. */
export default StickerPhoto;
